import NavigableValidator from "./navigableValidator";
import ObjectModelProperty from "../objectModelProperties/objectModelProperty";
import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import ValidationError from "../validationError";
import {ErrorType} from "~/enums/ErrorType";
import ObjectModelRelation from "../objectModelRelations/objectModelRelation";
import ObjectModel from "../objectModel";

export default class LinkedRelationMappedPropertiesValidator extends NavigableValidator<ObjectModelProperty> {
  _validatorKey = 'linked_relation_mapped_properties';
  defaultMessage = ValidationErrorMessage.MustBePresent;
  defaultType = ErrorType.mustBePresent;

  protected _validate(prop: ObjectModelProperty): void {
    if (!prop.linked_relation_client_id) return;
    const relation = ObjectModelRelation.repo.find(prop.linked_relation_client_id);
    if (!relation) return;
    
    // choose root model or related object models depending on direction of mapped property
    const root = relation.rootObjectModel && relation.rootModel.client_id !== relation.rootObjectModel.client_id
    const objectModels = root ? [relation.rootObjectModel] : relation.related_object_models
    let propertyType = null
    
    for (const linkedModel of objectModels) {
      const lrmp = prop.linked_relation_mapped_property(linkedModel.client_id);
      
      if (!lrmp) {
        const error = this.buildValidationError(prop, linkedModel);
        this.errors.push(error);
      }
    }
  }

  buildValidationError(prop: ObjectModelProperty, linkedModel: ObjectModel, message?): ValidationError {
    const validationError = super.buildValidationError(prop, linkedModel)
    const errorNavOpts = prop.validation.errorNavOpts(this, this.validatorKey)
    const targetElementId = linkedModel.idForProp('linked_relation_mapped_properties')
    Object.assign(errorNavOpts, {
      targetElementId: targetElementId
    })
    Object.assign(validationError, {
      displayName: `${linkedModel.title}'s Mapped Property`,
      errorNavOpts: errorNavOpts,
      field: targetElementId,
    })
    if (message)  {
      Object.assign(validationError, {
        message: message
      })
    }
    return validationError;
  }
}